// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ry-2";
export var chatLink = "_ry-0";
export var chatText = "_ry-1";